<template>
  <div
    class="border rounded p-3 mb-3"
    style="border-color: #ef9f27 !important;"
  >
    <div class="font-weight-bold small mb-2">Nuevo adicional</div>

    <b-row>
      <b-col cols="12">
        <b-form-group label="Servicio adicional (*)" label-size="sm">
          <b-input-group size="sm">
            <b-form-select
              v-model="form.skuServicio"
              :options="serviciosOptions"
              :disabled="loadingServicio"
              @change="$emit('buscar-servicio', form.skuServicio)"
            >
              <template #first>
                <b-form-select-option :value="''" disabled>
                  -- Selecciona un servicio --
                </b-form-select-option>
              </template>
            </b-form-select>
            <b-input-group-append v-if="loadingServicio">
              <b-input-group-text><b-spinner small/></b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <small v-if="!serviciosOptions.length" class="text-danger">
            No se encontraron servicios adicionales disponibles.
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6">
        <b-form-group label="SKU producto" label-size="sm">
          <div class="d-flex align-items-center">
            <b-form-input
              v-model="form.skuProducto"
              placeholder="Ingresa SKU"
              size="sm"
              class="flex-grow-1 mr-2"
            />
            <b-button
              class="btn-buscar-sku"
              size="sm"
              :disabled="!form.skuProducto || loadingProducto"
              @click="$emit('buscar-producto', form)"
            >
              <b-spinner v-if="loadingProducto" small class="mr-1" />
              <font-awesome-icon v-else icon="search" class="mr-1" />
              <span>Buscar</span>
            </b-button>
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Descripción producto" label-size="sm">
          <b-form-input size="sm" :value="form.descripcionProducto" disabled />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3">
        <b-form-group label="Cantidad" label-size="sm">
          <b-form-input
            v-model.number="form.cantidad"
            type="number"
            min="1"
            size="sm"
          />
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label="C. sin IGV" label-size="sm">
          <b-form-input size="sm" :value="form.costoSinIgv" disabled />
        </b-form-group>
      </b-col>
      <b-col cols="5">
        <b-form-group label="Total sin IGV" label-size="sm">
          <b-form-input size="sm" :value="totalLinea" disabled />
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label="Observación" label-size="sm">
      <b-form-textarea
        v-model="form.obsProveedor"
        rows="2"
        maxlength="500"
        placeholder="Detalle del adicional"
        size="sm"
      />
    </b-form-group>

    <b-alert v-if="error" show variant="warning" class="py-1 small mb-2">{{
      error
    }}</b-alert>

    <div class="d-flex justify-content-end">
      <b-button
        size="sm"
        variant="secondary"
        class="gc-modal-btn mr-2"
        @click="$emit('cancelar')"
        >Cancelar</b-button
      >
      <b-button
        size="sm"
        class="bg-orange-btn gc-modal-btn"
        @click="handleAgregar"
        >Agregar a la lista</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "GestorCentralizadoAdicionalForm",
  props: {
    value: { type: Object, default: () => ({}) },
    serviciosOptions: { type: Array, default: () => [] },
    loadingServicio: { type: Boolean, default: false },
    loadingProducto: { type: Boolean, default: false },
  },
  data() {
    return { form: { ...this.value }, error: "" };
  },
  computed: {
    totalLinea() {
      return (
        Number(this.form.costoSinIgv || 0) * Number(this.form.cantidad || 0)
      ).toFixed(2);
    },
  },
  watch: {
    value: {
      deep: true,
      handler(nuevo) {
        this.form = { ...nuevo };
      },
    },
  },
  methods: {
    handleAgregar() {
      if (!this.form.skuServicio) {
        this.error = "Ingresa el SKU del servicio.";
        return;
      }
      if (
        this.form.costoSinIgv === null ||
        this.form.costoSinIgv === undefined
      ) {
        this.error = "El servicio no tiene tarifa vigente para esta tienda.";
        return;
      }
      if (!this.form.skuProducto) {
        this.error = "Ingresa el SKU del producto.";
        return;
      }
      if (!this.form.descripcionProducto) {
        this.error = "Busca el producto para validar que el SKU exista.";
        return;
      }
      if (!Number(this.form.cantidad) || Number(this.form.cantidad) < 1) {
        this.error = "La cantidad debe ser mayor a 0.";
        return;
      }
      this.error = "";
      this.$emit("agregar", { ...this.form });
    },
  },
};
</script>
